<template>
  <div>
    <drop-down :multiLevel="true">
      <md-button class="md-button md-info dropdown-toggle md-wd">
        <img
          v-if="!selectedHierarchyObject.macList.length && getStatus(selectedHierarchyObject.mac) == 1"
          src="/img/green-dot.png"
          class="status-icon"
          title="Online"
        />

        <span
          v-if="!selectedHierarchyObject.macList.length && getStatus(selectedHierarchyObject.mac) == 2"
          class="dot dot-db-update"
          :title="$lang.general.status_db_update"
        ></span>

        <img
          v-if="!selectedHierarchyObject.macList.length && getStatus(selectedHierarchyObject.mac) == 0"
          src="/img/red-dot.png"
          class="status-icon"
          title="Offline"
        />

        <span class="item-icon">
          <i
            v-if="selectedHierarchyObject.isLeaf"
            :class="getDeviceIcon(selectedHierarchyObject.type)"
          ></i>
          <i v-else class="fa fa-home"></i>
        </span>
        <span :title="selectedHierarchyObject.title">{{headerLength(selectedHierarchyObject.title)}}</span>
      </md-button>

      <div class="dropdown-menu">
        <sl-vue-tree
          v-model="nodes"
          ref="slVueTree"
          :allowMultiselect="false"
          @select="nodeSelected"
          @drop="nodeDropped"
          @nodedblclick="nodeDblClick"
          @toggle="nodeToggled"
        >
          <template slot="title" slot-scope="{ node }">
            <span v-if="node.isLeaf">
              <img
                v-if="getStatus(node.data.mac) == 1"
                src="/img/green-dot.png"
                class="status-icon"
                title="Online"
              />

              <span
                v-if="getStatus(node.data.mac) == 2"
                class="dot dot-db-update"
                :title="$lang.general.status_db_update"
              ></span>

              <img
                v-if="getStatus(node.data.mac) == 0"
                src="/img/red-dot.png"
                class="status-icon"
                title="Offline"
              />
            </span>

            <span class="item-icon">
              <i v-if="node.isLeaf" :class="getDeviceIcon(node.data.type)"></i>
              <i v-else class="fa fa-home"></i>
            </span>

            <span v-if="node.data.isEdited">
              <md-field style="display: inline;">
                <md-input
                  style="display: inline; width:100px;"
                  :value="node.title"
                  v-focus
                  v-on:keyup.enter="submitEditedElement(node, $event.target.value)"
                  maxlength="24"
                ></md-input>
              </md-field>
            </span>

            <span
              v-if="!node.data.isEdited"
              @mouseenter="nodeMouseEnter(node, $event)"
              @mouseleave="nodeMouseLeave(node, $event)"
            >
              <span :title="node.title">{{titleLength(node.title, node.level, node.isLeaf)}}</span>

              <span v-if="!node.isLeaf">{{countOfChildren(node)}}</span>

              <md-button
                v-if="!node.isLeaf && node.data.showButton"
                class="md-button md-just-icon md-simple"
                @click="removeNode()"
              >
                <md-icon class="md-size-1x">close</md-icon>
              </md-button>

              <md-button
                v-if="!node.isLeaf && node.data.showButton"
                class="md-button md-just-icon md-simple"
                :title="$lang.titles.select_group"
                @click="selectGroup"
              >
                <md-icon class="md-size-1x">auto_awesome_motion</md-icon>
              </md-button>

              <md-button
                v-if="node.isLeaf && node.data.showButton"
                class="md-button md-just-icon md-simple"
                @click="openModal(node, $event)"
              >
                <md-icon class="md-size-1x">more_vert</md-icon>
              </md-button>
            </span>
          </template>

          <template slot="toggle" slot-scope="{ node }">
            <span v-if="!node.isLeaf">
              <i v-if="node.isExpanded" class="fa fa-chevron-down"></i>
              <i v-if="!node.isExpanded" class="fa fa-chevron-right"></i>
            </span>
          </template>

          <template slot="sidebar" slot-scope="{ node }">
            <md-chips
              v-model="menuTags[getTagIndex(node.data.id)].tags"
              class="md-primary"
              :md-limit="1"
              :md-placeholder="$lang.inputs.add_tag"
              @input="tagAdded(getTagIndex(node.data.id))"
              :md-static="node.isLeaf ? true : false"
            ></md-chips>
          </template>

          <template slot="draginfo">{{selectedHierarchyObject.dragTitle}}</template>
        </sl-vue-tree>

        <div class="hierarchy-new-object">
          <md-field>
            <label>{{$lang.keys.add_new_object}}</label>
            <md-input
              v-on:keyup.enter="submitNewElement()"
              v-model="newElement"
              maxlength="24"
              md-counter="false"
            ></md-input>
          </md-field>
        </div>
      </div>
    </drop-down>

    <md-snackbar :md-duration="5000" :md-active.sync="snackBarVisible">
      <span>{{snackBarMessage}}</span>
      <md-button class="md-info md-simple" @click="snackBarVisible = false">{{$lang.keys.close}}</md-button>
    </md-snackbar>

    <modal v-if="showModal" @close="modalClose">
      <template slot="header">
        <h4 class="modal-title">{{modalData.title}}</h4>
        <md-button class="md-simple md-just-icon md-round modal-default-button" @click="modalClose">
          <md-icon>clear</md-icon>
        </md-button>
      </template>

      <template slot="body">
        <md-table>
          <md-table-row>
            <md-table-cell>MAC</md-table-cell>
            <md-table-cell>{{modalData.mac}}</md-table-cell>
          </md-table-row>
        </md-table>

        <router-link v-if="modalData.status === 'ONLINE'" :to="{ name: 'device_settings'}">
          <md-button
            class="md-info md-block"
            :disabled="modalData.status !== 'ONLINE'"
          >{{$lang.menu.settings}}</md-button>
        </router-link>

        <md-button v-else class="md-info md-block" disabled>{{$lang.menu.settings}} (offline)</md-button>

        <h4 class="card-title">{{$lang.titles.location}}</h4>
        <div class="md-layout">
          <div class="md-layout-item">
            <md-field>
              <label>{{$lang.keys.latitude}}</label>
              <md-input v-model="modalData.lat" type="text"></md-input>
            </md-field>
          </div>

          <div class="md-layout-item">
            <md-field>
              <label>{{$lang.keys.longitude}}</label>
              <md-input v-model="modalData.lng" type="text"></md-input>
            </md-field>
          </div>
        </div>
      </template>

      <template slot="footer">
        <md-button class="md-primary" @click="saveModalData(modalData.mac)">{{$lang.keys.save}}</md-button>
        <md-button class="md-danger" @click="deleteModalDevice(modalData.mac)">{{$lang.keys.delete}}</md-button>
        <md-button class="md-simple" @click="modalClose">{{$lang.keys.close}}</md-button>
      </template>
    </modal>
  </div>
</template>


<script>
import { getUserToken, getSelectedDeviceToken } from "@/storage/memoryStorage";
import SlVueTree from "sl-vue-tree";
import { Modal } from "@/components";
import axios from "axios";
import Swal from "sweetalert2";

const focus = {
  inserted(el) {
    el.focus();
  }
};

export default {
  name: "hierarchy-menu",
  directives: { focus },
  components: {
    "sl-vue-tree": SlVueTree,
    Modal
  },
  props: {
    selectableGroup: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      modalData: {},
      showModal: false,
      modalLoaded: false,
      selectedHierarchyObject: {
        title: "",
        isLeaf: "",
        mac: "",
        macList: []
      },
      contextMenuIsVisible: false,
      newElement: "",
      snackBarMessage: "",
      snackBarVisible: false,
      updateRequest: false,
      nodes: [],
      menuTags: []
    };
  },
  computed: {
    getHierarchy() {
      return this.$store.getters.getHierarchy;
    },
    deviceList() {
      return this.$store.getters.getDeviceList;
    },
    getSelectedDevice() {
      return this.$store.getters.getSelectedDevice;
    },
    getAuth() {
      return this.$store.getters.getAuth;
    }
  },

  created() {
    this.getHierarchyAPI2();
  },

  mounted() {
    if (this.getSelectedDevice) {
      this.selectedHierarchyObject.title = this.getSelectedDevice.title;
      this.selectedHierarchyObject.mac = this.getSelectedDevice.mac;
      if (this.getSelectedDevice.hasOwnProperty("macList")) {
        this.selectedHierarchyObject.isLeaf = this.getSelectedDevice.macList
          .length
          ? false
          : true;
      } else {
        this.selectedHierarchyObject.isLeaf = true;
      }

      this.selectedHierarchyObject.type = Number(this.getSelectedDevice.type);
      this.selectedHierarchyObject.macList = this.getSelectedDevice.hasOwnProperty(
        "macList"
      )
        ? this.getSelectedDevice.macList
        : [];
    }
  },

  methods: {
    getDeviceLabel(deviceTypeID) {
      switch (deviceTypeID) {
        case 1:
          return "MeriTo";
        case 2:
          return "Disconnector";
        case 3:
          return "PTE/WS";
        case 4:
          return "Octopus";
        case 5:
          return "OutageDetector";
        case 6:
          return "MeriToNano";
        default:
          return "MeriTo";
      }
    },

    getDeviceIcon(deviceTypeID) {
      switch (deviceTypeID) {
        case 1:
          return "fa fa-charging-station";
        case 2:
          return "fa fa-toggle-on";
        case 3:
          return "fas fa-suitcase";
        case 4:
          return "fas fa-atom";
        case 5:
          return "fas fa-plug";
        case 6:
          return "fas fa-bolt";
        default:
          return "fa fa-charging-station";
      }
    },

    goSettingsLora() {
      this.$router.push({
        name: "lora_settings"
      });
    },

    headerLength(title) {
      if (title.length > 20) {
        return title.slice(0, 20) + "...";
      }
      return title;
    },

    titleLength(title, level, isLeaf) {
      if (isLeaf){
        if (title.length > 24) {
          return title.slice(0, 24) + "...";
        }
        return title;
      }

      if (level == 1){
        if (title.length > 24) {
          return title.slice(0, 24) + "...";
        }
      } 
      
      if (level == 2) {
          if (title.length > 22) {
          return title.slice(0, 22) + "...";
        }
      }

            if (level == 3) {
          if (title.length > 20) {
          return title.slice(0, 20) + "...";
        }
      }

      if (level == 4) {
          if (title.length > 14) {
          return title.slice(0, 14) + "...";
        }
      }

      if (level >= 5) {
          if (title.length > 8) {
          return title.slice(0, 8) + "...";
        }
      }

      return title;
    },

    getTagIndex(id) {
      let ret = null;
      ret = this.menuTags.findIndex(tag => tag.id == id);
      return ret;
    },

    saveModalData: function(mac) {
      const indexInMenu = this.getTagIndexByMAC(mac);

      this.menuTags[indexInMenu].lat = this.modalData.lat;
      this.menuTags[indexInMenu].lng = this.modalData.lng;

      this.updateHierarchyAPI();
      this.updateRequest = true;
      this.modalClose();
    },

    openModal: function(node, event) {
      this.modalLoaded = false;

      this.modalData.mac = node.data.mac;
      this.modalData.title =
        this.getDeviceLabel(node.data.type) + " " + node.title;
      //const deviceFW = this.deviceList[this.getIndexStatusList(node.data.mac)]
      //  .fw;
      this.modalData.status = this.deviceList[
        this.getIndexStatusList(node.data.mac)
      ].status;
      //this.modalData.fw = deviceFW ? deviceFW : "offline";
      //this.modalData.rssi = "offline";
      //this.modalData.uptime = "offline";
      this.modalData.lora = {};
      this.modalData.lora.plugged = false;

      const indexInMenu = this.getTagIndex(node.data.id);

      this.modalData.lat = this.menuTags[indexInMenu].lat;
      this.modalData.lng = this.menuTags[indexInMenu].lng;

      this.showModal = true;
    },

    modalClose: function() {
      this.showModal = false;
    },

    getStatus: function(mac) {
      try {
        const findDevice = this.deviceList[this.getIndexStatusList(mac)];

        if (findDevice.status == "ONLINE") {
          if (findDevice.connection) {
            if (findDevice.connection == "BT_MQTT_DB") {
              return 2;
            }
          }
          return 1;
        } else {
          return 0;
        }
      } catch (err) {
        return 0;
      }
    },

    getIndexStatusList(mac) {
      return this.deviceList.findIndex(e => e.mac == mac);
    },

    countOfChildren: function(node) {
      let counter = 0;

      node.children.forEach(element => {
        if (element.isLeaf) {
          counter++;
        }
      });

      if (counter > 0) {
        return " (" + counter + ")";
      } else {
        return "";
      }
    },

    updateHierarchyAPI() {
      const apiData = {
        nodes: this.nodes,
        tags: this.menuTags
      };

      axios({
        method: "POST",
        url: this.$ENDPOINTS.API_W + "/facility/devices-hierarchy",
        data: {
          token: getUserToken(),
          menu: JSON.stringify(apiData)
        },
        withCredentials: true
      })
        .then(response => {})
        .catch(error => {
          this.showSnackBar(this.$lang.messages.api_communication_error);
        });
    },

    deleteModalDevice(deviceMAC) {
      this.modalClose();

      Swal.queue([
        {
          title: this.$lang.general.are_you_sure,
          type: "warning",
          showCancelButton: true,
          cancelButtonClass: "md-button md-danger",
          cancelButtonText: this.$lang.keys.cancel,
          confirmButtonClass: "md-button md-success",
          confirmButtonText: this.$lang.keys.yes,
          buttonsStyling: false,
          showLoaderOnConfirm: true,

          preConfirm: () => {
            return axios({
              method: "DELETE",
              url: this.$ENDPOINTS.API_W + "/assign",
              data: {
                token: getSelectedDeviceToken(deviceMAC),
                login: this.getAuth.user
              },
              withCredentials: true
            })
              .then(response => {
                this.contextMenuIsVisible = false;
                const $slVueTree = this.$refs.slVueTree;
                const path = $slVueTree.getSelected().map(node => node.path);
                const nodeTitle = $slVueTree.getSelected().map(node => node);

                $slVueTree.remove(path);

                this.$store.commit(
                  "removeDeviceFromDeviceList",
                  nodeTitle[0].data.mac
                );
                this.menuTags.splice(this.getTagIndex(nodeTitle[0].data.id), 1);
                this.updateHierarchyAPI();
                this.updateRequest = true;
                let ifSelected = false;

                $slVueTree.traverse((node, nodeModel, path) => {
                  if (node.isLeaf && !ifSelected) {
                    ifSelected = true;
                    this.selectedHierarchyObject.title = node.title;
                    this.selectedHierarchyObject.mac = node.data.mac;
                    this.selectedHierarchyObject.type = Number(
                      this.getSelectedDevice.type
                    );

                    this.$store.commit("setSelectedDevice", {
                      title: this.selectedHierarchyObject.title,
                      mac: this.selectedHierarchyObject.mac
                    });
                  }
                });
              })
              .then(() => {
                Swal.insertQueueStep({
                  title: this.$lang.messages.success,
                  text: this.$lang.messages.success_removed_device,
                  type: "success",
                  confirmButtonClass: "md-button md-success",
                  confirmButtonText: this.$lang.keys.close,
                  buttonsStyling: false,
                  timer: 2000
                });
              })
              .catch(error => {
                Swal.insertQueueStep({
                  title: this.$lang.messages.error,
                  text: this.$lang.messages.api_communication_error,
                  type: "error",
                  confirmButtonClass: "md-button md-warning",
                  confirmButtonText: this.$lang.keys.close,
                  buttonsStyling: false
                });
              });
          }
        }
      ]);
    },

    getLastID() {
      let lastID = 1;

      try {
        this.menuTags.forEach(element => {
          try {
            if (element.id > lastID) {
              lastID = element.id;
            }
          } catch (err) {
            this.showSnackBar(this.$lang.messages.general_error);
          }
        });
        return lastID;
      } catch {
        return lastID;
      }
    },

    getHierarchyAPI2() {
      let saveHierarchyMenu = false;

      axios({
        method: "POST",
        url: this.$ENDPOINTS.API_R + "/facility/devices-hierarchy",
        data: {
          token: getUserToken()
        },
        withCredentials: true
      })
        .then(response => {
          this.nodes = response.data.data.nodes;
          this.menuTags = response.data.data.tags;

          this.deviceList.forEach(device => {
            if (this.getTagIndexByMAC(device.mac) == -1) {
              const deviceID = this.getLastID() + 1;

              let deviceTag = {
                id: deviceID,
                title: device.mac,
                mac: device.mac,
                tags: [this.getDeviceLabel(device.type)]
              };

              const deviceNode = {
                title: device.mac,
                isLeaf: true,
                data: {
                  id: deviceID,
                  mac: device.mac,
                  type: device.type
                }
              };

              this.menuTags.push(deviceTag);
              this.nodes.push(deviceNode);

              saveHierarchyMenu = true;
            }
          });
        })
        .catch(error => {
          if (error.response) {
            if (error.response.data.code === 610) {
              this.deviceList.forEach(device => {
                const deviceID = this.getLastID() + 1;

                let deviceTag = {
                  id: deviceID,
                  title: device.mac,
                  mac: device.mac,
                  tags: [this.getDeviceLabel(device.type)]
                };

                const deviceNode = {
                  title: device.mac,
                  isLeaf: true,
                  data: {
                    id: deviceID,
                    mac: device.mac,
                    type: device.type
                  }
                };

                this.menuTags.push(deviceTag);
                this.nodes.push(deviceNode);

                saveHierarchyMenu = true;
              });
            } else {
              this.showSnackBar(this.$lang.messages.api_communication_error);
            }
          }
        })
        .then(() => {
          if (saveHierarchyMenu) {
            this.updateHierarchyAPI();
            this.$store.commit("setOverviewStats", true);
          }
        });
    },

    showSnackBar(msg) {
      this.snackBarMessage = msg;
      this.snackBarVisible = true;
    },

    addNewObject(name) {
      const ID = this.getLastID() + 1;
      const tag = { id: ID, tags: [] };
      const node = {
        title: name,
        isExpanded: false,
        children: [],
        data: {
          id: ID
        }
      };

      this.nodes.push(node);
      this.menuTags.push(tag);
      this.updateHierarchyAPI();
      this.updateRequest = true;
    },

    submitNewElement() {
      this.addNewObject(this.newElement);
      this.newElement = "";
    },

    getTagIndexByMAC(deviceMAC) {
      try {
        return this.menuTags.findIndex(tag => tag.mac == deviceMAC);
      } catch {
        return -1;
      }
    },

    submitEditedElement(nodeSelected, newNodeTitle) {
      const slVueTree = this.$refs.slVueTree;
      event.stopPropagation();

      if (this.selectedHierarchyObject.title === nodeSelected.title) {
        this.selectedHierarchyObject.title = newNodeTitle;
        this.$store.commit("setSelectedDevice", {
          title: this.selectedHierarchyObject.title,
          mac: this.selectedHierarchyObject.mac
        });
      }

      let nodeData = Object.assign({}, nodeSelected.data);
      nodeData.isEdited = false;

      slVueTree.updateNode(nodeSelected.path, {
        title: newNodeTitle,
        data: nodeData
      });

      this.menuTags[this.getTagIndex(nodeData.id)].title = newNodeTitle;

      this.updateHierarchyAPI();
      this.updateRequest = true;
    },

    tagAdded(tagIndex) {
      if (this.menuTags[tagIndex].tags.length > 0) {
        if (this.menuTags[tagIndex].tags[0].length > 12) {
          this.menuTags[tagIndex].tags[0] =
            this.menuTags[tagIndex].tags[0].slice(0, 12) + "...";
        }
      }
      this.$store.commit("setOverviewStats", true);
      this.updateHierarchyAPI();
      this.updateRequest = true;
    },

    nodeDblClick(nodeSelected, event) {
      const slVueTree = this.$refs.slVueTree;
      event.stopPropagation();

      slVueTree.traverse((node, nodeModel, path) => {
        let nodeData = Object.assign({}, node.data);
        nodeData.isEdited = false;
        slVueTree.updateNode(node.path, { data: nodeData });
      });

      let nodeData = Object.assign({}, nodeSelected.data);
      nodeData.isEdited = true;

      slVueTree.updateNode(nodeSelected.path, {
        data: nodeData
      });
    },

    searchDevices(node) {
      let deviceList = [];
      node.forEach(device => {
        if (!device.isLeaf) {
          deviceList.push(...this.searchDevices(device.children));
        } else {
          //ONLY MeriTo
          if (device.data.type === 1 || !device.data.type) {
            deviceList.push(device.data.mac);
          }
        }
      });

      return deviceList;
    },

    nodeSelected(nodes, event) {
      if (this.showModal == false) {
        const slVueTree = this.$refs.slVueTree;
        event.stopPropagation();

        slVueTree.traverse((node, nodeModel, path) => {
          let nodeData = Object.assign({}, node.data);
          nodeData.isEdited = false;

          slVueTree.updateNode(node.path, {
            data: nodeData
          });
        });

        const isNodeLeaf = nodes.map(node => node.isLeaf)[0];

        if (isNodeLeaf === true) {
          // this.selectedHierarchyObject.mac = this.menuTags[this.getIndex(this.selectedHierarchyObject.title)].mac;
          this.selectedHierarchyObject.mac = nodes
            .map(node => node.data.mac)
            .join(", ");
          this.selectedHierarchyObject.type = Number(
            nodes.map(node => node.data.type).join(", ")
          );
          this.selectedHierarchyObject.macList = [];
          this.selectedHierarchyObject.title = nodes
            .map(node => node.title)
            .join(", ");
          this.selectedHierarchyObject.isLeaf = isNodeLeaf;

          this.$store.commit("setSelectedDevice", {
            title: this.selectedHierarchyObject.title,
            mac: this.selectedHierarchyObject.mac
          });
        } 
        
        // else if (this.selectableGroup) {
        //   const macList = this.searchDevices(nodes[0].children);

        //   if (macList.length > 0) {
        //     this.selectedHierarchyObject.title = nodes
        //       .map(node => node.title)
        //       .join(", ");
        //     this.selectedHierarchyObject.mac = macList[0];
        //     this.selectedHierarchyObject.isLeaf = isNodeLeaf;
        //     this.selectedHierarchyObject.macList = macList;

        //     this.$store.commit("setSelectedDevice", {
        //       title: this.selectedHierarchyObject.title,
        //       mac: this.selectedHierarchyObject.mac,
        //       macList: this.selectedHierarchyObject.macList
        //     });
        //   }
        // }

        this.selectedHierarchyObject.dragTitle = nodes
          .map(node => node.title)
          .join(", ");
      }
    },

    selectGroup() {
      const $slVueTree = this.$refs.slVueTree;
      const selectedNode = $slVueTree.getSelected()[0];
      const macList = this.searchDevices(selectedNode.children);

      if (macList.length > 0) {
        this.selectedHierarchyObject.title = selectedNode.title;
        this.selectedHierarchyObject.mac = macList[0];
        this.selectedHierarchyObject.isLeaf = selectedNode.isLeaf;
        this.selectedHierarchyObject.macList = macList;
        this.selectedHierarchyObject.dragTitle = selectedNode.title;

        this.$store.commit("setSelectedDevice", {
          title: this.selectedHierarchyObject.title,
          mac: this.selectedHierarchyObject.mac,
          macList: this.selectedHierarchyObject.macList
        });
      }
    },

    nodeDropped(nodes, position, event) {
      this.updateHierarchyAPI();
      this.updateRequest = true;
    },

    nodeToggled(node, event) {
      this.updateHierarchyAPI();
      this.updateRequest = true;
    },

    nodeMouseEnter(nodeSelected, event) {
      const slVueTree = this.$refs.slVueTree;
      event.stopPropagation();

      let nodeData = Object.assign({}, nodeSelected.data);
      nodeData.showButton = true;

      slVueTree.updateNode(nodeSelected.path, {
        data: nodeData
      });
    },

    nodeMouseLeave(nodeSelected, event) {
      const slVueTree = this.$refs.slVueTree;
      event.stopPropagation();

      let nodeData = Object.assign({}, nodeSelected.data);
      nodeData.showButton = false;

      slVueTree.updateNode(nodeSelected.path, {
        data: nodeData
      });
    },

    recursiveRemove(node) {
      let removedLeaf = [];
      if (Array.isArray(node)) {
        for (let child of node) {
          if (child.isLeaf) {
            removedLeaf.push(child.data.mac);
          } else {
            removedLeaf = removedLeaf.concat(this.recursiveRemove(child));
          }
        }
      } else {
        if (node) {
          if (node.children.length > 0) {
            removedLeaf = removedLeaf.concat(
              this.recursiveRemove(node.children)
            );
          }
        }
      }

      return removedLeaf;
    },

    removeNode() {
      this.contextMenuIsVisible = false;
      const $slVueTree = this.$refs.slVueTree;
      const path = $slVueTree.getSelected().map(node => node.path);
      const nodeTitle = $slVueTree.getSelected().map(node => node);
      const nodeChildren = $slVueTree.getSelected().map(node => node.children);

      Swal.queue([
        {
          title: this.$lang.general.are_you_sure,
          type: "warning",
          showCancelButton: true,
          cancelButtonClass: "md-button md-danger",
          cancelButtonText: this.$lang.keys.cancel,
          confirmButtonClass: "md-button md-success",
          confirmButtonText: this.$lang.keys.yes,
          buttonsStyling: false,
          showLoaderOnConfirm: true,

          preConfirm: async () => {
            $slVueTree.remove(path);
            const devicesToRemove = await this.recursiveRemove(nodeChildren);
            for (let deviceMAC of devicesToRemove) {
              this.menuTags.splice(this.getTagIndexByMAC(deviceMAC), 1);
            }
            this.menuTags.splice(this.getTagIndex(nodeTitle[0].data.id), 1);

            if (devicesToRemove.length == 0) {
              this.updateHierarchyAPI();
              this.updateRequest = true;

              Swal.insertQueueStep({
                title: this.$lang.messages.success,
                text: this.$lang.messages.success_removed_device,
                type: "success",
                confirmButtonClass: "md-button md-success",
                confirmButtonText: this.$lang.keys.close,
                buttonsStyling: false,
                timer: 2000
              });
            } else {
              axios({
                method: "DELETE",
                url: this.$ENDPOINTS.API_W + "/assign/list",
                data: {
                  userToken: getUserToken(),
                  deviceList: devicesToRemove
                },
                withCredentials: true
              })
                .then(response => {
                  this.updateHierarchyAPI();
                  this.updateRequest = true;
                  let ifSelected = false;

                  devicesToRemove.forEach(device => {
                    this.$store.commit("removeDeviceFromDeviceList", device);
                  });

                  $slVueTree.traverse((node, nodeModel, path) => {
                    if (node.isLeaf && !ifSelected) {
                      ifSelected = true;
                      this.selectedHierarchyObject.title = node.title;
                      this.selectedHierarchyObject.mac = node.data.mac;
                      this.selectedHierarchyObject.type = Number(
                        this.getSelectedDevice.type
                      );

                      this.$store.commit("setSelectedDevice", {
                        title: this.selectedHierarchyObject.title,
                        mac: this.selectedHierarchyObject.mac
                      });
                    }
                  });

                  this.$nextTick(() => {
                    Swal.insertQueueStep({
                      title: this.$lang.messages.success,
                      text: this.$lang.messages.success_removed_device,
                      type: "success",
                      confirmButtonClass: "md-button md-success",
                      confirmButtonText: this.$lang.keys.close,
                      buttonsStyling: false,
                      timer: 2000
                    });
                  });
                })
                .catch(error => {
                  Swal.insertQueueStep({
                    title: this.$lang.messages.error,
                    text: this.$lang.messages.api_communication_error,
                    type: "error",
                    confirmButtonClass: "md-button md-warning",
                    confirmButtonText: this.$lang.keys.close,
                    buttonsStyling: false
                  });
                });
            }
          }
        }
      ]);
    }
  }
};
</script>


<style lang="scss" scoped>
.md-button:not(.md-just-icon) .md-button-content i {
  height: 32px;
}

i {
  width: 33px;
  height: 33px;
  line-height: 33px;
  text-align: center;
}

.md-list {
  width: 320px;
  max-width: 100%;
  display: inline-block;
  vertical-align: top;
  border: 1px solid rgba(#000, 0.12);
}

.hierarchy-new-object {
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 5px;
  padding-bottom: 5px;
}

.md-button {
  height: 40px;
}

.md-card-actions .md-layout-item {
  padding: 0;
}

.md-chips.md-field {
  padding: 0;
  margin: 0;
}

.items-inline {
  display: inline;
}

.md-button.md-just-icon {
  height: 35px;
}

@media only screen and (min-width: 500px) {
  .dropdown-menu {
    width: 400px;
  }
}

@media only screen and (min-width: 550px) {
  .dropdown-menu {
    width: 450px;
  }
}

@media only screen and (max-width: 450px) {
  .dropdown-menu {
    left: -55px;
  }
}

.dropdown-menu {
  min-width: 350px;
}

.status-icon {
  width: 10px;
  height: auto;
  /*   margin-right: 12px;  */
}

.md-count {
  display: none;
}
</style>


<style lang="scss">
@import "./src/assets/scss/md/_variables";

.modal-container {
  color: var(
    --md-theme-default-text-primary-on-background-variant,
    rgba(0, 0, 0, 0.87)
  );
}

.md-chips.md-field .md-input {
  max-width: 90px;
}

.sl-vue-tree.sl-vue-tree-root {
  flex-grow: 1;
  overflow-x: hidden;
  overflow-y: auto;
  height: auto;
}

.sl-vue-tree {
  position: relative;
  cursor: default;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none;
}

.sl-vue-tree.sl-vue-tree-root {
  background-color: #ffffff;
  color: #414d5c;
  border-radius: 3px;
}

.sl-vue-tree-root > .sl-vue-tree-nodes-list {
  overflow: hidden;
  position: relative;
  padding-bottom: 4px;
}

.sl-vue-tree-selected > .sl-vue-tree-node-item {
  background-color: #ffffff;
  color: #414d5c;
}
.sl-vue-tree-node-item:hover,
.sl-vue-tree-node-item.sl-vue-tree-cursor-hover {
  background-color: $green-300;
  color: #ffffff;
  cursor: pointer;
}

.sl-vue-tree-node-item {
  position: relative;
  display: flex;
  flex-direction: row;

  padding-left: 10px;
  padding-right: 10px;
  line-height: 35px;
  border: 1px solid transparent;
}

.sl-vue-tree-node-item.sl-vue-tree-cursor-inside {
  border: 1px solid rgba(255, 255, 255, 0.5);
}

@media only screen and (max-width: 500px) {
  .sl-vue-tree-gap {
    width: 10px;
    min-height: 1px;
  }
}

@media only screen and (min-width: 500px) {
  .sl-vue-tree-gap {
    width: 25px;
    min-height: 1px;
  }
}

.sl-vue-tree-toggle {
  display: inline-block;
  text-align: left;
  width: 20px;
}

.sl-vue-tree-sidebar {
  margin-left: auto;
}

.sl-vue-tree-cursor {
  position: absolute;
  border: 1px solid rgba(255, 255, 255, 0.5);
  height: 1px;
  width: 100%;
}

.sl-vue-tree-drag-info {
  position: absolute;
  background-color: $green-400;
  opacity: 0.85;
  margin-left: 20px;
  padding: 5px 10px;
}

.item-icon {
  display: inline-block;
  text-align: left;
  /* width: 20px;
  padding-right: 7px; */
}

.dot {
  height: 10px;
  width: 10px;
  border-radius: 50%;
  display: inline-block;
}

.dot-db-update {
  background-color: #ff9800;
}
</style>

